// import echarts from "echarts";
export function loadChart(
  myChart,
  resultArr,
  nyear,
  bfData,
  czUnit,
  min = null
) {
  myChart.clear();
  if (bfData[0].length > 0) {
    let dataZoom = [];
    const shownum = 14;
    const okbfb = Math.ceil((shownum / bfData[0].length) * 100);
    if (bfData[0].length > 20) {
      dataZoom = [
        {
          start: 100 - okbfb,
          end: 100,
          zoomLock: true
        },
        {
          type: "inside"
        }
      ];
    }
    const option = {
      // 颜色设置
      color: [
        "#53cca9",
        "#0CB4FF",
        "#F3B90F",
        "#F86464",
        "#34A8FF",
        "#FA9022",
        "#19DC7C",
        "#F0ED00",
        "#8C70F8",
        "#00EEF0",
        "#00acee",
        "#52cdd5",
        "#79d9f1",
        "#a7e7ff",
        "#c8efff"
      ],
      tooltip: {
        //鼠标滑过交叉点的提示样式，默认是黑色半透明状态
        trigger: "axis",
        axisPointer: {
          label: {
            //X轴坐标文字样式
            show: true,
            backgroundColor: "#fff",
            color: "#556677",
            borderColor: "rgba(0,0,0,0)",
            shadowColor: "rgba(0,0,0,0)",
            shadowOffsetY: 0
          },
          lineStyle: {
            width: 0
          }
        },
        formatter: "{b}年{a}:{c}" + czUnit,
        backgroundColor: "#fff",
        textStyle: {
          color: "#5c6c7c"
        },
        padding: [10, 10],
        extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)"
      },
      legend: {
        show: false,
        //右上角线类型标记
        selectedMode: "single",
        data: resultArr,
        top: "-1",
        right: "15",
        icon: "circle", //图标点样式
        itemWidth: 6,
        itemGap: 20,
        // data: charts.names,
        textStyle: {
          fontSize: 14,
          color: "#fff"
        }
      },
      //
      grid: {
        top: 50,
        left: "15",
        right: "3%",
        bottom: "4%",
        containLabel: true
      },
      //横坐标设置
      xAxis: {
        type: "category",
        boundaryGap: false, //坐标轴两边留白
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
          //	margin:15,
          textStyle: {
            color: "#fff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12
          },
          margin: 10,
          rotate: 40
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false
        },
        axisLine: {
          //坐标轴轴线相关设置
          lineStyle: {
            color: "#02a7fd"
          }
        },
        splitLine: {
          //坐标轴在 grid 区域中的分隔线。
          show: false,
          lineStyle: {
            color: "#fff"
          }
        },
        data: nyear
      },
      //纵坐标设置
      yAxis: {
        name: "（单位：" + czUnit + "）", //Y轴坐标名称 or 单位
        nameTextStyle: {
          color: "#00cfff",
          fontSize: 13,
          // align: "left",
          padding: [0, 0, 5, 0]
        },
        scale: true,
        // max: max,
        // min: min,
        splitLine: {
          lineStyle: {
            //grid 区域内横坐标的线样式 此时为虚线
            // type: "dashed",
            color: "#162d4e"
          }
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false
        },
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 1, //设置为 1，表示『隔一个标签显示一个标签』
          //	margin:15,
          textStyle: {
            color: "#00deff",
            // fontStyle: "normal",
            // fontFamily: "微软雅黑",
            fontSize: 12
          }
          //rotate:50,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#08aeef"
          }
        }
      },
      dataZoom,
      series: [
        {
          name: resultArr[0],
          type: "line",
          smooth: true, //是否平滑
          itemStyle: {
            color: "#fff",
            borderColor: "#0e9cff"
          },
          lineStyle: {
            color: "#23e8cd"
          },
          areaStyle: {
            color: "rgba(13,67,90,.7)"
          },
          // itemStyle: {
          //   normal: {
          //     color: "#00A7FD",
          //     //交叉点的阴影样式
          //     lineStyle: {
          //       color: "#19B1FC",
          //       width: 3
          //     },
          //     areaStyle: {
          //       color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          //         {
          //           offset: 0,
          //           color: "rgba(248,137,64,0)"
          //         },
          //         {
          //           offset: 1,
          //           color: "rgba(0,167,253,0.35)"
          //         }
          //       ])
          //     }
          //   }
          // },
          symbol: "circle", //数据交叉点样式
          symbolSize: 9, //数据交叉点尺寸
          data: bfData[0]
          // markPoint: {
          // 	animationEasing: 'elasticOut',
          // 	animationDelay: function(idx) {
          // 		return idx * 200 + 1000
          // 	},
          // 	data: [
          // 		{
          // 			type: 'max',
          // 		},
          // 	],
          // },
        },
        {
          name: resultArr[1],
          type: "line",
          smooth: true,
          areaStyle: {},
          data: bfData[1]
        },
        {
          name: resultArr[2],
          type: "line",
          smooth: true,
          areaStyle: {},
          data: bfData[2]
        },
        {
          name: resultArr[3],
          type: "line",
          smooth: true,
          areaStyle: {},
          data: bfData[3]
        },
        {
          name: resultArr[4],
          type: "line",
          smooth: true,
          areaStyle: {},
          data: bfData[4]
        }
      ]
    };
    if (min !== null) {
      option.yAxis.min = min;
    }
    myChart.setOption(option);
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
